import onSelectionChange from '../events/onSelectionChange';
import keyboardMultiSelectRowInternal from '../internal/keyboardMultiSelectRowInternal';
import * as mailListSelectionActions from 'owa-mail-actions';
import { SelectionDirection } from 'owa-mail-list-store';
import { orchestrator } from 'satcheljs';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import multiselectNextRowInternal from '../internal/multiselectNextRowInternal';
/////////////////////////////////////// PLEASE READ ///////////////////////////////////////////////////////////
// This is a top level selection action, as such, it should never call other top-level selection
// actions in the same directory, but only call into internal subdirectories where the core logic is implemented.
// This prevents double logging for CTQs as well as prevents onSelectionChange from being fired multiple times
// for a single user action.
///////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default orchestrator(mailListSelectionActions.multiSelectNextRow, function (actionMessage) {
    var tableView = actionMessage.tableView, mailListItemSelectionSource = actionMessage.mailListItemSelectionSource, isCtrlDown = actionMessage.isCtrlDown;
    if (isMailFeatureEnabled('tri-selectionRefactor')) {
        keyboardMultiSelectRowInternal(tableView, SelectionDirection.Next, mailListItemSelectionSource, isCtrlDown);
    }
    else {
        multiselectNextRowInternal(tableView, mailListItemSelectionSource);
    }
    // Propagate selection change event
    onSelectionChange(tableView, true /* isUserNavigation */, mailListItemSelectionSource);
});
//# sourceMappingURL=multiselectNextRowOrchestrator.js.map